import { useEffect, useState } from "react";
import { Layout, SectionTitle } from "@/components/Layout";
import { DeviceCard, HelpBanner } from "@/components/cards";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

export default function DevicesPage() {
  const [devices, setDevices] = useState([]);
  const { openWhatsApp } = useSettings();
  useEffect(() => { api.get("/devices").then((r) => setDevices(r.data)); }, []);
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14">
        <SectionTitle label="Dispositivos" title="Escolha seu dispositivo"
          subtitle="Selecione seu aparelho para ver os tutoriais e aplicativos compatíveis." />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {devices.map((d) => <DeviceCard key={d.id} device={d} />)}
        </div>
        <div className="mt-10">
          <HelpBanner onWhatsApp={() => openWhatsApp("devices-page")} />
        </div>
      </div>
    </Layout>
  );
}
